// Dynamic Yield

export const sendFilterItemToDy = (filterGroup, filterName) => {
  if (!window.DY || typeof window.DY.API !== "function") {
    return; // Exit early if DY API is not available
  }

  const stringFilterName = String(filterName);
  const filterGroupMap = {
    colors: "color",
    manufacturers: "manufacturer",
    operatingSystems: "operating_system",
    storage: "storage_capacity",
  };

  const backendFilterGroupName = filterGroupMap[filterGroup] || filterGroup;

  const properties = {
    dyType: "filter-items-v1",
    filterType: backendFilterGroupName,
    // storage comes with an integer value, this is why we are using "filterNumericValue"
    [filterGroup === "storage" ? "filterNumericValue" : "filterStringValue"]:
      filterGroup === "storage" ? filterName : stringFilterName,
  };

  window.DY.API("event", {
    name: "Filter Items",
    properties,
  });
};
